export default __webpack_public_path__ + "CircularCustCapNum-Bold.fd11743ed182aa04b0a78677c37f6a6d.woff";